import {useAllAccountsQuery} from '@transactions/graphql';
import * as React from 'react';
import type {AccountListItemFragment} from '@transactions/graphql';

export const useAccountsById = (): Map<string, AccountListItemFragment> => {
  const {data} = useAllAccountsQuery();
  return React.useMemo(() => {
    const map = new Map<string, AccountListItemFragment>();
    for (const account of data?.allAccounts ?? []) {
      map.set(account._id, account);
    }
    return map;
  }, [data]);
};
